<div class="account-section">
  <div class="my-section-box">
    <form [formGroup]="customerForm">
      <div class="my-section-box__headline">{{'dataExtractionRquest.customerVehicleOwner'|cxTranslate}}
      </div>
      <div class="data-extraction__form">
        <div class="my-section-box-inner">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="companyName"
              class="control-label">{{'customerVehicleOwnerForm.companyName'|cxTranslate}}</label>
              <div class="input-wrapper-with-icon">
                <div class="input-with-icon">
                  <input class="form-control" formControlName="companyName" name="companyName"
                                        [ngClass]="{ 'is-valid':(customerForm?.get('companyName')?.dirty || submitted) && !customerForm?.get('companyName')?.errors, 
                                                    'is-invalid': (customerForm?.get('companyName')?.dirty || submitted) && customerForm?.get('companyName')?.errors }" />

                    <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info"
                      (click)="openPopupCompanyName()" />
                    </div>
                    @if (
                      customerForm.get('companyName')?.invalid &&
                      (customerForm.get('companyName')?.dirty ||
                      customerForm.get('companyName')?.touched ||
                      submitted)
                      ) {
                      <div class="invalid-feedback-icon">
                        {{'dataExtractionRquest.error_message'|cxTranslate}}
                      </div>
                    }
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                  <label for="contactName"
                  class="control-label">{{'customerVehicleOwnerForm.contactName'|cxTranslate}}</label>
                  <div class="input-wrapper-with-icon">
                    <div class="input-with-icon">
                      <input class="form-control" formControlName="contactName" name="contactName"
                                        [ngClass]="{ 'is-valid': (customerForm?.get('contactName').dirty || submitted) && !customerForm?.get('contactName')?.errors, 
                                                                                                'is-invalid': (customerForm?.get('contactName').dirty || submitted) && customerForm?.get('contactName')?.errors }">
                        <img src="/icons/question_dark_kb.svg" class="info-icon" alt="Back"
                          (click)="openPopupContactName()">
                        </div>
                        @if (
                          customerForm.get('contactName')?.invalid &&
                          (customerForm.get('contactName')?.dirty ||
                          customerForm.get('contactName')?.touched ||
                          submitted)
                          ) {
                          <div class="invalid-feedback-icon">
                            {{'dataExtractionRquest.error_message'|cxTranslate}}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <label for="email"
                      class="control-label">{{'customerVehicleOwnerForm.contactEmail'|cxTranslate}}</label>
                      <input type="email" class="form-control" formControlName="contactEmail"
                                [ngClass]="{ 'is-valid':(customerForm?.get('contactEmail')?.dirty || submitted) && !customerForm?.get('contactEmail')?.errors, 
                                            'is-invalid': (customerForm?.get('contactEmail').dirty || submitted) && customerForm?.get('contactEmail')?.errors }" />
                        <div class="invalid-feedback">
                          @if ( customerForm?.get('contactEmail')?.errors && customerForm?.get('contactEmail')?.errors['required']) {
                            <span class="text-danger-show"
                            >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                          }
                          @if ( customerForm?.get('contactEmail')?.errors && customerForm?.get('contactEmail')?.errors['contactEmail']) {
                            <span class="text-danger-show"
                            >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                          }
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <label for="contactPhone"
                        class="control-label">{{'customerVehicleOwnerForm.contactPhoneNumber'|cxTranslate}}</label>
                        <input type="text" formControlName="contactPhone" class="form-control" name="contactPhone"
                                [ngClass]="{ 'is-valid': (customerForm?.get('contactPhone').dirty || submitted) && !customerForm?.get('contactPhone')?.errors, 
                                                                'is-invalid': (customerForm?.get('contactPhone').dirty || submitted) && customerForm?.get('contactPhone')?.errors }">
                          <div class="invalid-feedback">
                            @if ( customerForm?.get('contactPhone')?.errors && customerForm?.get('contactPhone')?.errors['required']) {
                              <span class="text-danger-show"
                              >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                            }
                          </div>
                        </div>
                      </div>

                      <div class="row margin-top-25">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <label for="companyName"
                          class="control-label">{{'customerVehicleOwnerForm.companyAddresswithStreetNumber'|cxTranslate}}</label>
                          <input type="text" formControlName="address1" class="form-control" name="companyName"
                            [ngClass]="{ 'is-valid': (customerForm?.get('address1')?.dirty || submitted) && !customerForm?.get('address1')?.errors, 'is-invalid': (customerForm?.get('address1')?.dirty || submitted) && customerForm?.get('address1')?.errors }">
                            <div class="invalid-feedback">
                              @if ( customerForm?.get('address1')?.errors && customerForm?.get('address1')?.errors['required']) {
                                <span class="text-danger-show"
                                >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                              }
                            </div>
                          </div>
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="address2"
                            class="control-label">{{'customerVehicleOwnerForm.address2'|cxTranslate}}</label>
                            <input type="text" formControlName="address2" class="form-control" name="address2">
                          </div>
                        </div>

                        <div class="row margin-top-25">
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="city"
                            class="control-label">{{'customerVehicleOwnerForm.city'|cxTranslate}}</label>
                            <input type="text" formControlName="city" class="form-control" name="city"
                              [ngClass]="{ 'is-valid': (customerForm?.get('city')?.dirty || submitted) && !customerForm?.get('city')?.errors, 'is-invalid': (customerForm?.get('city')?.dirty || submitted) && customerForm?.get('city')?.errors }">
                              <div class="invalid-feedback">
                                @if ( customerForm?.get('city')?.errors && customerForm?.get('city')?.errors['required']) {
                                  <span class="text-danger-show"
                                  >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                }
                              </div>
                            </div>

                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <label for="state"
                              class="control-label">{{'customerVehicleOwnerForm.state'|cxTranslate}}</label>
                              <div class="select-box">
                                <select name="state" class="form-control" formControlName="state"
                                    [ngClass]="{ 'is-valid': (customerForm?.get('state').dirty || submitted) && !customerForm?.get('state')?.errors, 
                                                                                            'is-invalid': (customerForm?.get('state').dirty || submitted) && customerForm?.get('state')?.errors }">
                                  <option value="null" disabled selected>
                                  {{'common.register_state_placeholder'|cxTranslate}}</option>
                                  @for (item of stateList?.regionsWSList; track item) {
                                    <option [value]="item.isocode">
                                    {{item.name}}</option>
                                  }
                                </select>
                                <div class="invalid-feedback">
                                  @if ( customerForm?.get('state')?.errors && customerForm?.get('state')?.errors['required']) {
                                    <span class="text-danger-show"
                                      >
                                      <span>{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="row margin-top-25">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <label for="zip"
                              class="control-label">{{'customerVehicleOwnerForm.zipPostalCode'|cxTranslate}}</label>
                              <input type="text" maxlength="15" formControlName="zip" class="form-control" name="zip"
                                [ngClass]="{ 'is-valid': (customerForm?.get('zip')?.dirty || submitted) && !customerForm?.get('zip')?.errors, 'is-invalid': (customerForm?.get('zip')?.dirty || submitted) && customerForm?.get('zip')?.errors }">
                                <div class="invalid-feedback">
                                  @if ( customerForm?.get('zip')?.errors && customerForm?.get('zip')?.errors['required']) {
                                    <span class="text-danger-show"
                                    >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                  }
                                </div>

                              </div>
                              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                @if ((pageFieldData$|async); as pageFieldData) {
                                  <label for="country"
                                  class="control-label">{{'customerVehicleOwnerForm.country'|cxTranslate}}</label>
                                  <div class="select-box">
                                    <select name="country" class="form-control" formControlName="country"
                                      (change)="onCountryChange($event)"
                                      [ngClass]="{ 'is-valid': (customerForm?.get('country')?.dirty || submitted) && !customerForm?.get('country')?.errors, 'is-invalid': (customerForm?.get('country').dirty || submitted) && customerForm?.get('country')?.errors }">
                                      <option value="null" disabled selected>
                                      {{'common.form_register_empty'|cxTranslate}}</option>
                                      @for (item of pageFieldData['countriesWSList']; track item) {
                                        <option
                                        [value]="item.isocode">{{item.name}}</option>
                                      }
                                    </select>
                                    <div class="invalid-feedback">
                                      @if ( customerForm?.get('country')?.errors && customerForm?.get('country')?.errors['required']) {
                                        <span class="text-danger-show"
                                        >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                      }
                                    </div>
                                  </div>
                                }

                              </div>
                            </div>

                            <div class="endsure-btnblock">
                              <button class="btn-action btn-back mt-4" (click)="back()">
                                <img src="/icons/link_left_white.svg" class="next-icon-right default-icon" alt="Back">
                              {{ 'dataExtractionRquest.back' | cxTranslate }}</button>

                              <button class="btn-action btn-next mt-4" [disabled]="!customerForm.valid"
                                (click)="next()">{{'dataExtractionRquest.Next'|cxTranslate}}
                                <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="Next">
                              </button>

                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <!-- Popup for customerName -->
                  @if (popupOpenCompanyName) {
                    <div class="popup-backdrop"></div>
                  }

                  @if (popupOpenCompanyName) {
                    <div class="popup-modal">
                      <div class="popup-header">
                        <button class="close-btn" aria-label="close dialog" (click)="closePopupCompanyName()">
                          <img src="/icons/close-light-grey.svg" alt="" />
                        </button>
                      </div>
                      <div class="popup-body">
                        <span class="popup-title">{{'customerVehicleOwnerForm.company_name_popup_title'|cxTranslate}}</span>
                        <p class="mt-3">{{'customerVehicleOwnerForm.company_name_popup_content'|cxTranslate}}</p>
                      </div>
                    </div>
                  }

                  <!-- Popup for contactName -->
                  @if (popupOpenContactName) {
                    <div class="popup-backdrop"></div>
                  }

                  @if (popupOpenContactName) {
                    <div class="popup-modal">
                      <div class="popup-header">
                        <button class="close-btn" aria-label="close dialog" (click)="closePopupContactName()">
                          <img src="/icons/close-light-grey.svg" alt="" />
                        </button>
                      </div>
                      <div class="popup-body">
                        <span class="popup-title">{{'customerVehicleOwnerForm.contact_name_popup_title'|cxTranslate}}</span>
                        <p class="mt-3">{{'customerVehicleOwnerForm.contact_name_popup_content'|cxTranslate}}</p>
                      </div>
                    </div>
                  }